<template>
  <div class="flash-card-deck">
    <div class="container">
      <div class="row">
        <div class="col offset-2 col-8">
          <DeckHeader :deck="deck" />
          <Study
            mode="study"
            :deck="deck"
            :login-email="loginEmail"
            :signup-email="signupEmail"
            :forgotten-password="currentForm === 'forgottenPassword'"
            @tabChange="formChange"
            @signup="formChange('signup')"
            @login="formChange('login')"
            @reset-form="resetForms"
          >
            <LoginForm
              v-if="currentForm === 'login'" slot="form" flashcards
              :hide-socials="loginEmail"
              flashcards-study
              :show-form="showForm"
              type="login"
              @forgotten-password="formChange('forgottenPassword')"
              @email-choice="loginEmail = !loginEmail"
            />
            <SignupForm
              v-if="currentForm === 'signup'" slot="form" flashcards
              :hide-socials="signupEmail"
              flashcards-study
              type="signup"
              @email-choice="signupEmail = !signupEmail"
            />
            <ForgottenPassword
              v-if="currentForm === 'forgottenPassword'"
              slot="form"
              flashcards
              flashcards-study
              type="forgotten-password"
              @email-choice="backToLoginForm"
            />
          </Study>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeckHeader from '@itbpbg/lms-components/src/Flashcards/DeckHeader.vue';
import Study from '@itbpbg/lms-components/src/Flashcards/Study.vue';
import global from '@itbpbg/lms-components/src/mixins/global';
import LoginForm from '../../../components/LoginForm';
import SignupForm from '../../../components/SignupForm';
import ForgottenPassword from '../../../components/Flashcards/ForgottenPassword.vue';

export default {
  components: {
    DeckHeader,
    Study,
    SignupForm,
    LoginForm,
    ForgottenPassword,
  },
  mixins: [global],
  async asyncData({ $axios, route, error }) {
    const deck = await $axios.$get(`/flashcards/${route.params.slug}/study${route.query.difficult ? `?difficult=${route.query.difficult}` : ''}`).catch(() => false);
    if (!deck) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    return { deck };
  },
  data() {
    return {
      currentForm: 'login',
      loginEmail: false,
      signupEmail: false,
      showForm: false,
    };
  },
  head() {
    const metaTitle = `${this.deck.metatitle} – Study Deck`;
    let metaDescription = this.deck.metadescription;

    if (this.$route.query.share) {
      metaDescription = `I just completed the ${this.deck.title} flashcards deck with ${this.deck.results.testScore.score}% mastery. Can you beat my score? Try out the 365 Data Science Flashcards and ace your next learning challenge.`;
    }

    return {
      titleTemplate: `${metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps({
        ...this.deck,
        metaTitle,
        metaDescription,
        robots: 'noindex, follow',
      }),
    };
  },
  methods: {
    formChange(currentForm) {
      this.currentForm = currentForm;
      this.showForm = false;
    },
    resetForms() {
      this.loginEmail = false;
      this.signupEmail = false;
    },
    backToLoginForm() {
      this.showForm = true;
      this.currentForm = 'login';
    },
  },
};
</script>
